<template>
    <div class="manual-fields-setup">
        <h3>Задайте поля вручную</h3>
        <p class="setup-hint">
            Укажите названия полей, которые будут подставляться в шаблон грамоты.
        </p>

        <div class="fields-list">
            <div v-for="(field, index) in fields" :key="index" class="field-row">
                <span class="field-label">Поле {{ index + 1 }}:</span>
                <InputText
                    v-model="field.name"
                    :placeholder="'Название поля'"
                    class="p-inputtext-sm field-input"
                />
                <PrimeButton
                    v-if="fields.length > 1"
                    icon="pi pi-times"
                    class="p-button-sm p-button-text p-button-danger"
                    @click="removeField(index)"
                />
            </div>
        </div>

        <PrimeButton
            label="Добавить поле"
            icon="pi pi-plus"
            class="p-button-sm p-button-outlined"
            @click="addField"
        />

        <div v-if="validationError" class="validation-error">
            {{ validationError }}
        </div>

        <div class="action-buttons">
            <PrimeButton
                label="Отмена"
                class="p-button-secondary p-button-outlined"
                @click="$emit('cancel')"
            />
            <PrimeButton
                label="Создать структуру"
                class="p-button-primary"
                @click="createStructure"
            />
        </div>
    </div>
</template>

<script>
import api from "@/libs/api";

export default {
    name: "ManualFieldsSetup",
    props: {
        projectId: {
            type: Number,
            required: true
        }
    },
    emits: ['created', 'cancel', 'needs-confirmation'],
    data() {
        return {
            fields: [
                { name: '' },
                { name: '' },
                { name: '' }
            ],
            validationError: ''
        };
    },
    methods: {
        addField() {
            this.fields.push({ name: '' });
        },
        removeField(index) {
            this.fields.splice(index, 1);
        },
        validate() {
            this.validationError = '';

            const filledFields = this.fields.filter(f => f.name.trim());
            if (filledFields.length === 0) {
                this.validationError = 'Необходимо заполнить хотя бы одно поле';
                return false;
            }

            const names = this.fields.map(f => f.name.trim());
            const duplicates = names.filter((name, idx) => name && names.indexOf(name) !== idx);
            if (duplicates.length > 0) {
                this.validationError = 'Названия полей не должны повторяться';
                return false;
            }

            return true;
        },
        async createStructure() {
            if (!this.validate()) return;

            const fieldNames = this.fields
                .map(f => f.name.trim())
                .filter(n => n);

            try {
                const result = await api.createDataKeys(this.projectId, fieldNames);
                this.$emit('created', result.keys);
            } catch (err) {
                if (err.response && err.response.data.error === 'data_replacement_requires_confirmation') {
                    this.$emit('needs-confirmation', {
                        currentRowCount: err.response.data.current_row_count,
                        fields: fieldNames
                    });
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Ошибка',
                        detail: 'Не удалось создать структуру полей',
                        life: 5000
                    });
                }
            }
        }
    }
}
</script>

<style scoped>
.manual-fields-setup {
    max-width: 500px;
    margin: 0 auto;
    padding: 24px;
    background: #f8f9fa;
    border-radius: 8px;
}

h3 {
    margin-bottom: 8px;
    text-align: center;
}

.setup-hint {
    color: #6c757d;
    text-align: center;
    margin-bottom: 24px;
}

.fields-list {
    margin-bottom: 16px;
}

.field-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
}

.field-label {
    min-width: 60px;
    color: #6c757d;
}

.field-input {
    flex: 1;
}

.validation-error {
    color: #dc3545;
    font-size: 0.875rem;
    margin: 12px 0;
    padding: 8px;
    background: #f8d7da;
    border-radius: 4px;
}

.action-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 20px;
}
</style>
